import axios from "axios"
import { CCTextarea } from "../commonComponents/inputFields"

export const AITimerTemplateEditor = (props) => {

    const handleUserQuestion = (text) => {
        console.log(text)
        getUpdatedStyle(text)
    }

    const getUpdatedStyle = async (text) => {
      try {
        let url = `${process.env.REACT_APP_LION_API_URL}/AIEditors/templates/timer/`;
        let response = await axios.post(url, {query: text});

        console.log(response.data)
                
      } catch (error) {
        console.log(error);
      }

    
    }


    return <div className="font-poppins text-ccColorDarkTeal">
              <div className="mt-2">Tell me how you would like your timer templated to be styled.</div>
            <CCTextarea onChange={handleUserQuestion} />
    </div>

}